import { Product, RegisteredDietitian } from '../types'

export const mockRD: RegisteredDietitian = {
  name: 'Dr. Sarah Chen',
  credentials: 'RD, CDN',
  avatar:
    'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=150&h=150&fit=crop',
  planSummary: [
    'Focus on lean proteins and whole grains',
    'Limit sodium to 2000mg per day',
    'Include 5+ servings of fruits & vegetables',
    'Choose low-fat dairy options',
  ],
}

export const mockProducts: Product[] = [
  {
    id: '1',
    name: 'Organic Spinach',
    price: 3.99,
    size: '10 oz',
    image:
      'https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=300&h=300&fit=crop',
    category: 'Produce',
    rdRecommendation: 'recommended',
    rdNote: 'Excellent source of iron and vitamins! Perfect for your plan.',
    nutrition: { calories: 23, protein: 3, carbs: 4, fat: 0 },
  },
  {
    id: '2',
    name: 'Wild Salmon Fillet',
    price: 12.99,
    size: '1 lb',
    image:
      'https://images.unsplash.com/photo-1574781330855-d0db8cc6a79c?w=300&h=300&fit=crop',
    category: 'Protein',
    rdRecommendation: 'recommended',
    rdNote: 'Great lean protein choice with omega-3s!',
    nutrition: { calories: 206, protein: 22, carbs: 0, fat: 13 },
  },
  {
    id: '3',
    name: 'Whole Grain Bread',
    price: 4.49,
    size: '24 oz',
    image:
      'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=300&h=300&fit=crop',
    category: 'Bakery',
    rdRecommendation: 'recommended',
    rdNote: 'Whole grains support your energy goals!',
    nutrition: { calories: 80, protein: 4, carbs: 15, fat: 1 },
  },
  {
    id: '4',
    name: 'Potato Chips',
    price: 3.99,
    size: '8 oz',
    image:
      'https://images.unsplash.com/photo-1566478989037-eec170784d0b?w=300&h=300&fit=crop',
    category: 'Snacks',
    rdRecommendation: 'limit',
    rdNote: 'High in sodium. Try baked veggie chips instead?',
    healthierAlternative: '13',
    nutrition: { calories: 160, protein: 2, carbs: 15, fat: 10 },
  },
  {
    id: '5',
    name: 'Greek Yogurt (Low-fat)',
    price: 5.99,
    size: '32 oz',
    image:
      'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=300&h=300&fit=crop',
    category: 'Dairy',
    rdRecommendation: 'recommended',
    rdNote: 'Perfect protein-rich snack! Love this choice.',
    nutrition: { calories: 100, protein: 17, carbs: 6, fat: 0 },
  },
  {
    id: '6',
    name: 'Frozen Pizza',
    price: 6.99,
    size: '12 inch',
    image:
      'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=300&h=300&fit=crop',
    category: 'Frozen',
    rdRecommendation: 'limit',
    rdNote: 'High in sodium and saturated fat. Consider making homemade?',
    healthierAlternative: '14',
    nutrition: { calories: 320, protein: 12, carbs: 36, fat: 14 },
  },
  {
    id: '7',
    name: 'Fresh Blueberries',
    price: 4.99,
    size: '6 oz',
    image:
      'https://images.unsplash.com/photo-1498557850523-fd3d118b962e?w=300&h=300&fit=crop',
    category: 'Produce',
    rdRecommendation: 'recommended',
    rdNote: 'Antioxidant powerhouse! Great for snacking.',
    nutrition: { calories: 84, protein: 1, carbs: 21, fat: 0 },
  },
  {
    id: '8',
    name: 'Quinoa',
    price: 7.99,
    size: '16 oz',
    image:
      'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=300&h=300&fit=crop',
    category: 'Grains',
    rdRecommendation: 'recommended',
    rdNote: 'Complete protein and fiber-rich. Excellent choice!',
    nutrition: { calories: 222, protein: 8, carbs: 39, fat: 4 },
  },
  {
    id: '9',
    name: 'Soda (12-pack)',
    price: 5.99,
    size: '12 pack',
    image:
      'https://images.unsplash.com/photo-1629203851122-3726ecdf080e?w=300&h=300&fit=crop',
    category: 'Beverages',
    rdRecommendation: 'limit',
    rdNote: 'High in sugar. Sparkling water with fruit is a great swap!',
    healthierAlternative: '15',
    nutrition: { calories: 140, protein: 0, carbs: 39, fat: 0 },
  },
  {
    id: '10',
    name: 'Almond Butter',
    price: 8.99,
    size: '16 oz',
    image:
      'https://images.unsplash.com/photo-1599599810769-bcde5a160d32?w=300&h=300&fit=crop',
    category: 'Pantry',
    rdRecommendation: 'recommended',
    rdNote: 'Healthy fats and protein. Great with your whole grain bread!',
    nutrition: { calories: 98, protein: 3, carbs: 3, fat: 9 },
  },
  {
    id: '11',
    name: 'Chicken Breast',
    price: 9.99,
    size: '1.5 lb',
    image:
      'https://images.unsplash.com/photo-1604503468506-a8da13d82791?w=300&h=300&fit=crop',
    category: 'Protein',
    rdRecommendation: 'recommended',
    rdNote: 'Lean protein staple. Perfect for meal prep!',
    nutrition: { calories: 165, protein: 31, carbs: 0, fat: 4 },
  },
  {
    id: '12',
    name: 'Ice Cream',
    price: 5.49,
    size: '1 pint',
    image:
      'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=300&h=300&fit=crop',
    category: 'Frozen',
    rdRecommendation: 'neutral',
    rdNote: 'Enjoy in moderation! Consider portion size.',
    nutrition: { calories: 207, protein: 4, carbs: 24, fat: 11 },
  },
  {
    id: '13',
    name: 'Baked Veggie Chips',
    price: 4.49,
    size: '7 oz',
    image:
      'https://images.unsplash.com/photo-1600952841320-db92ec4047ca?w=300&h=300&fit=crop',
    category: 'Snacks',
    rdRecommendation: 'recommended',
    rdNote: 'Much lower in sodium and baked, not fried. Great swap!',
    nutrition: { calories: 120, protein: 2, carbs: 18, fat: 4 },
  },
  {
    id: '14',
    name: 'Cauliflower Pizza Crust',
    price: 7.99,
    size: '10 inch',
    image:
      'https://images.unsplash.com/photo-1571997478779-2adcbbe9ab2f?w=300&h=300&fit=crop',
    category: 'Frozen',
    rdRecommendation: 'recommended',
    rdNote: 'Lower carb, more veggies! Add your own healthy toppings.',
    nutrition: { calories: 180, protein: 8, carbs: 20, fat: 8 },
  },
  {
    id: '15',
    name: 'Sparkling Water with Fruit',
    price: 4.99,
    size: '8 pack',
    image:
      'https://images.unsplash.com/photo-1625772452859-1c03d5bf1137?w=300&h=300&fit=crop',
    category: 'Beverages',
    rdRecommendation: 'recommended',
    rdNote: 'Zero sugar, refreshing, and hydrating. Perfect alternative!',
    nutrition: { calories: 0, protein: 0, carbs: 0, fat: 0 },
  },
]

export const categories = [
  'All',
  'Produce',
  'Protein',
  'Dairy',
  'Bakery',
  'Snacks',
  'Frozen',
  'Beverages',
  'Grains',
  'Pantry',
]
